/* nf-pdp-reviews.js
   Baut die Bewertungs-Karten der PDP-Section "NF PDP · Reviews" aus den echten
   Judge.me-Daten. Seite 1 steht als Inline-JSON im Judge.me-App-Block
   (window.jdgm.data.reviewWidget[produktId]); weitere Seiten holt "Mehr Bewertungen"
   ueber denselben Endpunkt, den das Widget selbst nutzt. */
(function () {
  'use strict';

  var ENDPOINT = 'https://cdn.judge.me/reviews/reviews_for_widget';
  var escaper = document.createElement('div');

  function esc(value) {
    escaper.textContent = value == null ? '' : String(value);
    return escaper.innerHTML;
  }

  function text(html) {
    escaper.innerHTML = String(html == null ? '' : html);
    return (escaper.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function stars(rating) {
    var full = Math.round(Number(rating) || 0);
    var out = '';
    for (var i = 1; i <= 5; i++) out += i <= full ? '★' : '☆';
    return out;
  }

  function initials(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '★';
    var out = parts[0].charAt(0);
    if (parts.length > 1) out += parts[parts.length - 1].charAt(0);
    out = out.toUpperCase().replace(/[^0-9A-ZÄÖÜ]/g, '');
    return out || '★';
  }

  function card(review) {
    var body = text(review.body || review.body_html);
    if (!body) return '';

    var reply = text(review.reply_content);
    var replyName = text(review.shop_reply_name);
    var html = '<article class="nf-pdp-reviews__card">';
    html += '<p class="nf-pdp-reviews__stars nf-pdp-reviews__stars--card" aria-hidden="true">' + stars(review.rating) + '</p>';
    html += '<blockquote>„' + esc(body) + '“</blockquote>';
    if (reply) {
      html += '<details class="nf-pdp-reviews__reply"><summary>Antwort von ' +
        esc(replyName || 'naturafit') + '</summary><p>' + esc(reply) + '</p></details>';
    }
    html += '<cite><span class="nf-pdp-reviews__avatar" aria-hidden="true">' + esc(initials(review.reviewer_name)) + '</span>';
    html += '<span>' + esc(review.reviewer_name);
    if (review.verified_buyer) {
      html += ' <span class="nf-pdp-reviews__verified">✓ Verifizierter Kauf</span>';
    }
    html += '</span></cite></article>';
    return html;
  }

  function inlineData(productId) {
    try {
      var store = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
      if (store && store[productId]) return store[productId];
    } catch (error) {
      return null;
    }
    return null;
  }

  function fetchPage(root, page) {
    var query =
      '?product_id=' + encodeURIComponent(root.dataset.productId) +
      '&page=' + page +
      '&sort_by=created_at&sort_dir=desc&skip_other_languages=true&widget_theme=standard' +
      '&shop_domain=' + encodeURIComponent(root.dataset.shopDomain) +
      '&platform=shopify';
    return fetch(ENDPOINT + query).then(function (response) {
      if (!response.ok) throw new Error('Judge.me ' + response.status);
      return response.json();
    });
  }

  /* Der Button in der Kopfzeile gehoert der Vorlage, das Formular dem Judge.me-Widget.
     Er zeigt sich erst, wenn das Widget seinen eigenen Button aufgebaut hat, und loest
     diesen dann aus. Das Widget baut bei Bedarf neu auf, deshalb wird der Button zum
     Klickzeitpunkt frisch gesucht. */
  function wireWriteButton(root) {
    var own = root.querySelector('[data-nf-reviews-write]');
    var host = root.querySelector('[data-nf-reviews-jm]');
    if (!own || !host) return;

    function widgetButton() {
      return host.querySelector('.jm-action-buttons__button, .jdgm-write-rev-link');
    }

    own.addEventListener('click', function () {
      var target = widgetButton();
      if (target) target.click();
    });

    var tries = 0;
    var timer = setInterval(function () {
      if (widgetButton()) {
        own.hidden = false;
        clearInterval(timer);
      } else if (++tries > 40) {
        clearInterval(timer);
      }
    }, 250);
  }

  function setup(root) {
    var strip = root.querySelector('[data-nf-reviews-strip]');
    var more = root.querySelector('[data-nf-reviews-more]');
    var moreBtn = root.querySelector('[data-nf-reviews-more-btn]');
    if (!strip) return;

    var page = parseInt(root.dataset.page, 10) || 0;
    var totalPages = parseInt(root.dataset.totalPages, 10) || 1;
    var busy = false;

    function append(payload) {
      var reviews = (payload && payload.reviews) || [];
      var pagination = (payload && payload.pagination) || {};
      page = pagination.current_page || page + 1;
      totalPages = pagination.total_pages || totalPages;

      var html = '';
      for (var i = 0; i < reviews.length; i++) html += card(reviews[i]);
      strip.insertAdjacentHTML('beforeend', html);

      if (more) more.hidden = page >= totalPages || !strip.children.length;
    }

    function load(next) {
      if (busy || next > totalPages) return Promise.resolve();
      busy = true;
      if (moreBtn) moreBtn.disabled = true;
      return fetchPage(root, next)
        .then(append)
        .catch(function () {
          if (more) more.hidden = true;
        })
        .then(function () {
          busy = false;
          if (moreBtn) moreBtn.disabled = false;
        });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        load(page + 1);
      });
    }

    wireWriteButton(root);

    if (strip.children.length) return;

    var first = inlineData(root.dataset.productId);
    if (first) {
      page = 0;
      append(first);
    } else {
      page = 0;
      load(1);
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-section-type="nf-pdp-reviews"]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
